module.exports = __webpack_public_path__ + "static/media/Johan&Carma(71).68a0212e.jpg";